import { accountFunding } from "../../infrastructure/repository/company-repository";
import { addContextLog } from "../../infrastructure/log";
import { translate } from "../../infrastructure/translate/localization";

function toCents(number) {
  return +`${number}`.replace(/\./g, "") * 100;
}

export async function startAccountFunding(amount) {
  const amountToFund = toCents(amount);
  if (amountToFund < 3500) {
    alert(translate("my-account-section.minimum-recharge"));
  } else {
    const { data } = await accountFunding({ amountToFund });
    addContextLog("info", "accountFunding", "process", {
      response: data,
    });

    const redirectTo = data.paymentGatewayUrl;

    window.location.assign(redirectTo);
  }
}
